import { z } from "zod";
import { BaseSchema } from "../BaseSchema";
import { CustomerSchema } from "./Customer";
export var CustomerSMSSentSchema = BaseSchema.extend({
    customer: z.union([z.string(), CustomerSchema]),
    message: z.string(),
    destination: z.string()
});
